<template>
  <div>
    <!--  创建用户弹框组件-->
    <el-dialog
      :title="$t('common.createUser')"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="60%"
      :append-to-body="true"
      :before-close="handleClose"
    >
      <!--  表单-->
      <el-form
        ref="ruleForm"
        :rules="rules"
        :model="ruleForm"
        class="demo-form-inline"
        label-width="120px"
      >
        <el-form-item :label="$t('common.name') + ':'" prop="name" width="20px">
          <el-input
            v-model="ruleForm.name"
            :placeholder="$t('common.pleaseInputValue')"
          ></el-input>
          <!-- <p>{{$t('common.accountTip')}}</p> -->
        </el-form-item>
        <el-form-item
          :label="$t('common.jigou') + ':'"
          prop="organName"
          width="20px"
        >
          <el-input
            type="textarea"
            v-model="ruleForm.organName"
            :placeholder="$t('common.pleaseInputValue')"
            maxlength="1000"
          ></el-input>
        </el-form-item>
        <!-- {{ruleForm.roleCode}} -->
        <el-form-item
          :label="$t('common.role') + ':'"
          prop="roleCode"
          width="20px"
          v-if="authorityRole"
        >
          <el-select
            v-model="ruleForm.roleCode"
            :placeholder="$t('common.pleaseChose')"
            style="width: 200px"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.roleName"
              :value="item.roleCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('common.account') + ':'"
          prop="account"
          width="20px"
        >
          <el-input
            v-model="ruleForm.account"
            :placeholder="$t('common.pleaseInputValue')"
          ></el-input>
          <p>{{ $t("common.accountTip") }}</p>
        </el-form-item>
        <el-form-item
          :label="$t('common.contactEmail') + ':'"
          prop="mail"
          width="20px"
        >
          <el-input
            v-model="ruleForm.email"
            :placeholder="$t('common.pleaseInputValue')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.contactPhone') + ':'" width="20px">
          <el-input
            v-model="ruleForm.phone"
            :placeholder="$t('common.pleaseInputValue')"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <div class="foot-box" style="text-align: center">
          <el-button @click="dialogVisible = false">{{
            $t("common.cancelSpace")
          }}</el-button>
          <el-button type="primary" @click="onSubmit">{{
            $t("common.createSpace")
          }}</el-button>
        </div>
      </span>
      <organ-add-component
        ref="organ-add-component"
        @choseOrgan="choseOrgan"
      ></organ-add-component>
    </el-dialog>
    <el-dialog
      :title="''"
      :visible.sync="createVisible"
      :close-on-click-modal="false"
      width="450px"
      append-to-body
    >
      <div class="createSuccessBox" v-if="$store.state.dict.lang == 'zh'">
        <h2>创建新账号成功</h2>
        <p>账号：{{ ruleForm.account }}</p>
        <p>密码：{{ ruleForm.password }}（请及时登录修改初始密码）</p>
        <p style="color: #ddd">请及时联系TA修改初始密码</p>
      </div>
      <div class="createSuccessBox" v-if="$store.state.dict.lang == 'en'">
        <h2>A new account has been created</h2>
        <p>Account Name: {{ ruleForm.account }}</p>
        <p>Password: {{ ruleForm.password }}</p>
        <p>Please contact the author to change the initial password.</p>
      </div>
      <organ-add-component
        ref="organ-add-component"
        @choseOrgan="choseOrgan"
      ></organ-add-component>
    </el-dialog>
  </div>
</template>

<script>
import createUserTipComponent from "@/components/user/createUserTipComponent";
import organAddComponent from "./createUser/organAddComponent";
export default {
  props: ["isShowRoleSelect"],
  data() {
    return {
      authorityRole: false,
      dialogVisible: false,
      options: [],
      ruleForm: {
        name: "",
        organName: "",
        organCode: "",
        account: "",
        password: "123456",
        email: "",
        phone: "",
        roleCode: "",
      },
      createVisible: false,
      rules: {
        name: [{ required: true, message: " ", trigger: "blur" }],
        organName: [{ required: true, message: " ", trigger: "blur" }],
        account: [{ required: true, message: " ", trigger: "blur" }],
        password: [
          { required: true, message: " ", trigger: "blur" },
          {
            min: 6,
            max: 18,
            pattern: /^[A-Za-z0-9]{6,18}$/,
            message: this.$t("common.pleaseInputPass"),
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: this.$t("common.pleaseInput"),
            trigger: "blur",
          },
          {
            pattern:
              /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
            message: "请输入正确的邮箱",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.authorityRole = this.authorityObj.isShow("#5#63#65");
    this.getUserRoleRelationship();
  },
  components: {
    createUserTipComponent,
    organAddComponent,
  },
  methods: {
    //初始化弹出列表
    handleOpen() {
      this.dialogVisible = true;
    },
    handleClose(done) {
      done();
      this.resetForm();
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done();
      //   })
      //   .catch(_ => {});
    },
    onSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.createAccountInfo();
        } else {
          return false;
        }
      });

      // this.dialogVisible = false
    },
    resetForm() {
      this.ruleForm = {
        name: "",
        organName: "",
        organCode: "",
        account: "",
        password: "123456",
        mail: "",
        phone: "",
        roleCode: this.ruleForm.roleCode,
      };
    },
    choseOrgan(item) {
      this.ruleForm.organCode = item.organCode;
      this.ruleForm.organName = item.organName;
    },
    /**
     * 请求相关 创建用户
     * */
    createAccountInfo() {
      let data = {
        userName: this.ruleForm.name,
        // orgCode:this.ruleForm.organCode,
        org: this.ruleForm.organName,
        loginName: this.ruleForm.account,
        password: this.ruleForm.password,
        email: this.ruleForm.email,
        phoneNumber: this.ruleForm.phone,
        roleCode: this.ruleForm.roleCode,
        meetingCode: this.$store.state.dict.currentMeetingCode,
      };
      this.$api.createAccountInfo(data).then((res) => {
        if (res.code == 200) {
          this.dialogVisible = false;
          // this.$message.success("创建成功")
          this.createVisible = true;
          this.$emit("successCallBack", "");
        } else {
          if (this.$i18n.locale == "en" && res.retMsgEn) {
            this.$message({
              message: res.retMsgEn,
              type: "error",
            });
          } else {
            this.$message({
              message: res.retMsg,
              type: "error",
            });
          }
        }
      });
    },
    getUserRoleRelationship() {
      this.$api.getUserRoleRelationship().then((res) => {
        if (res.code == 200) {
          this.options = res.data;
          // console.log('res.data',res.data)
          // this.ruleForm.roleCode = '#role1#role2#role4';
          if (res.data.length > 0) {
            this.ruleForm.roleCode = res.data[0].roleCode;
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.foot-box {
  p {
    text-align: left;
  }
}
.createSuccessBox {
  width: 420px;
  margin: 0 auto;
  h2 {
    text-align: center;
    color: rgb(114, 192, 64);
    margin-bottom: 12px;
  }
  p {
    color: #000;
    line-height: 26px;
  }
}
</style>
